export var VERSION = '2.18.0';
//# sourceMappingURL=version.js.map